import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";
import { MdEventAvailable, MdLocationOn, MdSchedule } from "react-icons/md";

export default function ViewEvent({ uuid }) {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([getData()]);
    setReady(true);
  }

  async function getData() {
    await callApi("get-event-data", { uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    });
  }

  function getEventDateLabel() {
    if (!data) {
      return "";
    }

    if (data.startDate && data.endDate) {
      return `${data.startDate} - ${data.endDate}`;
    }

    return data.startDate || data.endDate || "Date TBA";
  }

  useEffect(() => {
    init();
  }, [uuid]);

  if (ready && data) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="event-view-shell">
              <div className="event-view-copy">
                <div className="publication-badge mb-3">
                  <span>Event</span>
                </div>
                <h6 className="main-section-title font-semi-bold mb-3">
                  {data.title}
                </h6>
                <div className="event-view-meta">
                  <span className="event-view-meta-item">
                    <MdSchedule size={18} className="me-2" />
                    {getEventDateLabel()}
                  </span>
                  {data.location ? (
                    <span className="event-view-meta-item">
                      <MdLocationOn size={18} className="me-2" />
                      {data.location}
                    </span>
                  ) : null}
                  {data.dateCreated ? (
                    <span className="event-view-meta-item">
                      <MdEventAvailable size={18} className="me-2" />
                      Posted {formatDate(data.dateCreated)}
                    </span>
                  ) : null}
                </div>
              </div>

              {data.photo ? (
                <div className="event-view-image-wrap">
                  <img
                    src={CDN_URL + data.photo}
                    alt={data.title}
                    className="event-view-image"
                  />
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-md-12 mt-4 mb-4">
            <div
              className="event-view-description"
              dangerouslySetInnerHTML={{ __html: data.description || "" }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
